import * as Type from './actionsTypes';

const fetchUnreadCount = () => ({ type: Type.NOTIFICACAO_FETCH_COUNT });

const fetchNotificacaoPreview = () => ({ type: Type.NOTIFICACAO_FETCH_PREVIEW });

const markNotificacaoRead = (id, wasUnread) => ({
  type: Type.NOTIFICACAO_MARK_READ,
  id,
  wasUnread: !!wasUnread,
});

const markAllNotificacoesRead = ({ tipo, modulo, arquivada } = {}) => ({
  type: Type.NOTIFICACAO_MARK_ALL_READ,
  tipo: tipo || null,
  modulo: modulo || null,
  arquivada: arquivada === true || arquivada === false ? arquivada : false,
});

/**
 * Lote oficial: PATCH /notificacoes/lote
 * Action usa `lida` na UI; a saga envia `visualizada` no body (contrato atual).
 * Envie `lida` e/ou `arquivada` (boolean). Arquivar no servidor também marca como lida.
 */
const markNotificacoesLote = ({ ids, lida, arquivada } = {}) => ({
  type: Type.NOTIFICACAO_LOTE,
  ids: Array.isArray(ids) ? ids : [],
  lida,
  arquivada,
});

export {
  fetchUnreadCount,
  fetchNotificacaoPreview,
  markNotificacaoRead,
  markAllNotificacoesRead,
  markNotificacoesLote,
};
